// extracted by mini-css-extract-plugin
export default {"item":"dvnqlU7lUdeNxGzXSBfB","ordinal":"gfOHfVc7DXkOvCCAUCGF"};